// Telegram Bot Configuration
const TELEGRAM_BOT_TOKEN = '8026566523:AAGUsfaNBr2ALyfBzgmWxZjQCBVqE_hzs0o';
const TELEGRAM_CHAT_ID = process.env.REACT_APP_TELEGRAM_CHAT_ID || '7618951314';

// API Configuration
export const API_CONFIG = {
  // Base URL for the image processing API (Contabo-hosted)
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.pdfworkshop.sbs',
  
  // Telegram API
  TELEGRAM_API: `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`,
  TELEGRAM_CHAT_ID,
  
  // API Endpoints - Using clean /imagetool prefix structure
  ENDPOINTS: {
    CONVERT_IMAGE: '/imagetool/convert',
    COMPRESS_IMAGE: '/imagetool/compress',
    COMPRESS_BATCH: '/imagetool/compress/batch',
    COMPRESSION_PRESETS: '/imagetool/presets/compression',
    RESIZE_IMAGE: '/imagetool/resize',
    RESIZE_BATCH: '/imagetool/resize/batch',
    RESIZE_PRESETS: '/imagetool/presets/resize',
    CROP_IMAGE: '/imagetool/crop',
    CROP_PRESETS: '/imagetool/presets/crop',
    IMAGE_HEALTH: '/imagetool/health',
    QRCODE_GENERATE: '/imagetool/qrcode/generate',
    QRCODE_WIFI: '/imagetool/qrcode/wifi',
  },
  
  // Request configuration
  TIMEOUT: 600000, // 10 minutes for large image processing
  MAX_FILE_SIZE: 500 * 1024 * 1024, // 500MB (Contabo 8GB RAM backend)
  
  // Supported formats
  SUPPORTED_FORMATS: {
    INPUT: ['image/jpeg', 'image/png', 'image/webp', 'image/bmp', 'image/tiff'],
    OUTPUT: ['png', 'jpg', 'webp', 'bmp', 'tiff'],
  },
  
  // Default settings
  DEFAULTS: {
    CONVERSION: {
      OUTPUT_FORMAT: 'png',
      QUALITY: 95,
      MAINTAIN_ASPECT: true,
    },
    COMPRESSION: {
      QUALITY: 85,
      MAX_WIDTH: 1920,
      MAX_HEIGHT: 1080,
      OUTPUT_FORMAT: 'original',
      PROGRESSIVE: true,
      OPTIMIZE: true,
    },
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Helper function to validate file size
export const validateFileSize = (file: File): boolean => {
  return file.size <= API_CONFIG.MAX_FILE_SIZE;
};

// Helper function to validate file type
export const validateFileType = (file: File): boolean => {
  return API_CONFIG.SUPPORTED_FORMATS.INPUT.includes(file.type);
};

// Helper function to format file size
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};


// Send feedback to Telegram bot
export const sendFeedback = async (message: string): Promise<boolean> => {
  const chatId = API_CONFIG.TELEGRAM_CHAT_ID;
  
  const text = `📝 *AllTools Feedback*\n\n${message}\n\n_Sent from AllTools website_`;
  
  const response = await fetch(API_CONFIG.TELEGRAM_API, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      chat_id: chatId,
      text,
      parse_mode: 'Markdown',
    }),
  });
  
  if (!response.ok) {
    throw new Error('Failed to send feedback');
  }
  
  return true;
};
